import * as turf from '@turf/turf'
import MapBox from '../modules/map'

// Event Service should be used for all events related needs, AVSEC (Aviation) Alerts, International SOS Alerts etc.

// Point Coordinates [latitude, longitude]
export const filterInternationalSOSAlerts = (internationalSOSAlerts, pointCoordinates, radius = 50) => {
    const latitudeNumber = Number(pointCoordinates[0])
    const longitudeNumber = Number(pointCoordinates[1])
    const point = turf.point([longitudeNumber, latitudeNumber])
    const buffered = turf.buffer(point, radius, { units: 'kilometers' })
    const polygon = turf.polygon(buffered.geometry.coordinates)
    const filteredAlerts = []

    internationalSOSAlerts.forEach(alert => {
        let distanceFromTheAirport = 0
        let alertWithinTheArea = alert.Locations.features.find(location => {
            const pointToCheck = turf.point([location.geometry.coordinates[0], location.geometry.coordinates[1]])
            const isInside = turf.booleanPointInPolygon(pointToCheck, polygon)

            if (isInside) {
                // Rount the number to nearest decimal
                distanceFromTheAirport = Math.round(turf.distance(point, pointToCheck, { units: 'kilometers' }) * 10) / 10
            }

            // Ignore country level alerts
            if (location.properties.Name === location.properties.CountryNameList) return false

            return isInside
        })

        if (alertWithinTheArea !== undefined) {
            alert.distanceFromAirport = distanceFromTheAirport
            filteredAlerts.push(alert)
        }
    })

    return filteredAlerts
}

const _filterInternationalSOSCountryAlerts = (internationalSOSAlerts, ISO_3166_1_ALPHA_3) => {
    if (internationalSOSAlerts.length === 0) return []

    const sanitizedCountryCode = ISO_3166_1_ALPHA_3.toLowerCase().trim()
    return internationalSOSAlerts.filter(alert => {
        if (alert.CountryIsoList !== undefined) {
            return alert.CountryIsoList.toLowerCase().indexOf(sanitizedCountryCode) > -1
        } else {
            return alert.Locations.features.some(featureLocation => {
                return featureLocation.properties.CountryIsoList.toLowerCase().indexOf(sanitizedCountryCode) > -1
            })
        }
    })
}

export const filterInternationalSOSCountryAlerts = (internationalSOSAlerts, ISO_3166_1_ALPHA_3) => {
    return _filterInternationalSOSCountryAlerts(internationalSOSAlerts, ISO_3166_1_ALPHA_3)
}

// This function will filter alerts for a particular city/location and also return all alerts issued that affect the whole country
// This will not return alerts that were issued towards different cities in that country. Used by the COMSTAT module
// coordinates - [latitude, longitude]
export const filterInternationalSOSCityAndCountryAlerts = (internationalSOSAlerts, pointCoordinates, ISO_3166_1_ALPHA_3, radius = 50) => {
    if (internationalSOSAlerts.length === 0) return []

    const latitudeNumber = Number(pointCoordinates[0])
    const longitudeNumber = Number(pointCoordinates[1])
    const point = turf.point([longitudeNumber, latitudeNumber])
    const buffered = turf.buffer(point, radius, { units: 'kilometers' })
    const polygon = turf.polygon(buffered.geometry.coordinates)

    // Need API to pass as the latitude and longitude, so we can  determine if it's not a country alert if the alert is in the range of the airport/city
    // the alerts that come from here have a different structure
    const countryAlerts = _filterInternationalSOSCountryAlerts(internationalSOSAlerts, ISO_3166_1_ALPHA_3)
    return countryAlerts.filter(alert => {
        if (alert.LocationName !== alert.CountryNameList) {
            // Here we know that locations refer to some local coordinates, we have airport coordinates passed
            // so we need to check if the alert is in the range of the airport

            let alertWithinTheArea = alert.Coordinates.some(location => {
                const pointToCheck = turf.point([location[0], location[1]])
                const isInside = turf.booleanPointInPolygon(pointToCheck, polygon)

                return isInside
            })

            return alertWithinTheArea
        } else {
            // If this is country level na it matches, then we don't need to do anything, we already filtered by country
            return true
        }
    })
}

export const unhighlightHotspot = () => {
    const existingLayer = MapBox.map.getLayer('hotspots-outline-highlighted')
    if (existingLayer !== undefined) {
        MapBox.map.setLayoutProperty('hotspots-outline-highlighted', 'visibility', 'none')
    }
}

export const checkIfAlertsAreInAirportRange = (airports, alertCordinates, radius = 50) => {
    const point = turf.point(alertCordinates)
    const buffered = turf.buffer(point, radius, { units: 'kilometers' })
    const polygon = turf.polygon(buffered.geometry.coordinates)
    let isInsideAirportRange = []
    airports.forEach(airport => {
        const pointToCheck = turf.point([airport.Lat, airport.Lng])
        const isInside = turf.booleanPointInPolygon(pointToCheck, polygon)
        if (isInside) {
            isInsideAirportRange.push(isInside)
        }
    })
    return isInsideAirportRange.length > 0 ? true : false
}

export const findIfAlertsAreInAirportRange = (affectedLocation, pointCoordinates, radius = 50) => {
    if (affectedLocation?.Coordinates?.length > 0) {
        const latitudeNumber = Number(pointCoordinates[0])
        const longitudeNumber = Number(pointCoordinates[1])
        const point = turf.point([longitudeNumber, latitudeNumber])
        const buffered = turf.buffer(point, radius, { units: 'kilometers' })
        const polygon = turf.polygon(buffered.geometry.coordinates)

        let distanceFromTheAirport = 0

        const pointToCheck = turf.point([affectedLocation.Coordinates[0], affectedLocation.Coordinates[1]])
        const isInside = turf.booleanPointInPolygon(pointToCheck, polygon)
        if (isInside) {
            // Count the number to nearest decimal
            distanceFromTheAirport = Math.round(turf.distance(point, pointToCheck, { units: 'kilometers' }) * 10) / 10
            return distanceFromTheAirport
        } else {
            return ""
        }
    } else {
        return ""
    }
}